import React, { useState } from "react";
import styled from "styled-components";
import Button from "../Button/Button";
import { colors } from "../../theme/color";
import { useSelector } from "react-redux";
import { RootState } from "../../store/rootReducer";
import { useQuery } from "@apollo/client";
import { GET_USER_BY_ID } from "../../graphql/queries/userManagement";
interface SkipTutorial {
  handleSkipTutorial?: () => void;
}

const WelcomeModal: React.FC<SkipTutorial> = ({ handleSkipTutorial }) => {
  const [isWelcomeModalOpen, setIsWelcomeModalOpen] = useState(true);

  const id = useSelector((state: RootState) => state.user?.user.id);

  const {
    loading: queryLoading,
    error: queryError,
    data: queryData,
  } = useQuery(GET_USER_BY_ID);

  const userDetails = queryData?.getUserById;

  return (
    <ModalWrapper>
      {isWelcomeModalOpen && (
        <WelcomeContainer>
          <Title>Welcome to Fipay 👋</Title>
          <SubTitle>
            {userDetails?.fullName ? userDetails.fullName : ""}
          </SubTitle>
          <Paragraph>
            Get ready to make smarter money moves, achieve your financial goals,
            and experience banking like never before.
          </Paragraph>
          <Paragraph2>Let’s show you how</Paragraph2>
          <Button
            id={""}
            onClick={handleSkipTutorial}
            padding={"10px 80px"}
            title="Continue"
            green
          />
          {/*<Skip onClick={handleSkipTutorial}>Skip Tutorial</Skip>*/}
        </WelcomeContainer>
      )}
    </ModalWrapper>
  );
};

export default WelcomeModal;

const WelcomeContainer = styled.div`
  width: 25.5%;
  flex-shrink: 0;
  border-radius: 0.75rem;
  background: var(
    --General-Background-2,
    linear-gradient(107deg, #ffffea 0%, #f3f2f1 42.92%, #dcebff 100%)
  );

  box-shadow:
    0px 8px 8px -4px rgba(16, 24, 40, 0.03),
    0px 20px 24px -4px rgba(16, 24, 40, 0.08);
  padding: 3% 7.2%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;

  @media only screen and (max-width: 767px) {
    width: 80%;
  }
`;

export const ModalWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  background: rgba(167, 167, 167, 0.7);
  backdrop-filter: blur(8px);
  z-index: 10000;
`;
const Paragraph = styled.div`
  color: ${colors.DARK_GRAY};
  text-align: center;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
  letter-spacing: 0.0175rem;
  margin: 0;
  padding: 0;

  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;
const Paragraph2 = styled.div`
  color: ${colors.DARK_GRAY};
  text-align: center;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
  letter-spacing: 0.0175rem;
  margin: 0;
  padding: 1.5rem 0;

  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;
const Title = styled.span`
  color: ${colors.DARK_GRAY};
  text-align: center;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5rem;
  letter-spacing: 0.02rem;
`;

const SubTitle = styled.h4`
  color: ${colors.BLACK};
  font-size: 1.625rem;
  font-weight: 700;
  line-height: 2rem;
  letter-spacing: 0.03125rem;
  margin: 0;
  padding: 0;
`;
const Skip = styled.span`
  color: ${colors.GREEN};
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5rem;
  letter-spacing: 0.02rem;
  cursor: pointer;
`;
